var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45_9104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45_9104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 13.8333C11.1448 13.8333 10.9864 13.7694 10.8587 13.6416C10.7309 13.5138 10.667 13.3555 10.667 13.1666V9.83329C10.667 9.6444 10.7309 9.48607 10.8587 9.35829C10.9864 9.23052 11.1448 9.16663 11.3337 9.16663H12.667C12.8559 9.16663 13.0142 9.23052 13.142 9.35829C13.2698 9.48607 13.3337 9.6444 13.3337 9.83329V13.1666C13.3337 13.3555 13.2698 13.5138 13.142 13.6416C13.0142 13.7694 12.8559 13.8333 12.667 13.8333H11.3337ZM7.33366 13.8333C7.14477 13.8333 6.98644 13.7694 6.85866 13.6416C6.73088 13.5138 6.66699 13.3555 6.66699 13.1666V3.83329C6.66699 3.6444 6.73088 3.48607 6.85866 3.35829C6.98644 3.23051 7.14477 3.16663 7.33366 3.16663H8.66699C8.85588 3.16663 9.01421 3.23051 9.14199 3.35829C9.26977 3.48607 9.33366 3.6444 9.33366 3.83329V13.1666C9.33366 13.3555 9.26977 13.5138 9.14199 13.6416C9.01421 13.7694 8.85588 13.8333 8.66699 13.8333H7.33366ZM3.33366 13.8333C3.14477 13.8333 2.98644 13.7694 2.85866 13.6416C2.73088 13.5138 2.66699 13.3555 2.66699 13.1666V7.16663C2.66699 6.97774 2.73088 6.8194 2.85866 6.69163C2.98644 6.56385 3.14477 6.49996 3.33366 6.49996H4.66699C4.85588 6.49996 5.01421 6.56385 5.14199 6.69163C5.26977 6.8194 5.33366 6.97774 5.33366 7.16663V13.1666C5.33366 13.3555 5.26977 13.5138 5.14199 13.6416C5.01421 13.7694 4.85588 13.8333 4.66699 13.8333H3.33366Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar_chart.2a038c429f8070c510c30687638405eb.svg";
export { ForwardRef as ReactComponent };